
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/news-events/[eventSlug]",
      function () {
        return require("private-next-pages/about-us/news-events/[eventSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/news-events/[eventSlug]"])
      });
    }
  